import { useState } from "react";

export const useDataTableState = () => {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  return {
    isSearchExpanded,
    setIsSearchExpanded,
  };
};
